import styled from 'styled-components'

import { Modal } from 'antd'

// import theme from 'configs/theme'

const Styled = styled(Modal)`
  .ant-modal-content {
    border-radius: 20px;
    background-color: #f9fcff;

    .ant-modal-close {
      .anticon {
        font-size: 24px;
      }
    }

    .ant-modal-header {
      border-bottom: 0;
      border-radius: 20px 20px 0 0;
      background-color: #f9fcff;

      .ant-modal-title {
        font-size: 20px;
      }
    }

    .ant-modal-body {
    }

    .ant-modal-footer {
      border-top: 0;
    }
  }
`

export default Styled
